import { https , httpsFile } from './http.js' ;

export function index () {
    return https().get( '/role' ) ;
}

export function datatable(page,currentpage){
    return httpsFile().get(`/roles-table?page=${page}&currentpage=${currentpage}`) ;
}

export function show (id) {
    return https().get( `/role/${id}` ) ;
}

export function create () {
    return https().get( `/role/create` ) ;
}

export function store (data) {
    return https().post(`/role`,data) ;
}

export function update (id,data){
    return httpsFile().post(`/role/${id}`,data);
}

export function destroy ( id ) {
    return httpsFile().delete( `/role/${id}` )
}